import { ItemCatalog } from "src/interfaces/ItemCatalog";

export const hideOutOfStock = (data: ItemCatalog[]): ItemCatalog[] => {
    return data.filter((item: any) => {
        const quantity = item.custom_attributes?.on_hand_quantity;
        const status = item.custom_attributes?.on_hand_status;
        return !(quantity === 0 || quantity === "0" || status === 3 || status === "3");
      });
}